import { render, staticRenderFns } from "./textBookDialog.vue?vue&type=template&id=3a601e84&scoped=true"
import script from "./textBookDialog.vue?vue&type=script&lang=js"
export * from "./textBookDialog.vue?vue&type=script&lang=js"
import style0 from "./textBookDialog.vue?vue&type=style&index=0&id=3a601e84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a601e84",
  null
  
)

export default component.exports